(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cm-about-amz"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('cm-about-amz')){
 customElements.define('cm-about-amz',class extends HTMLElement{
  connectedCallback(){
   this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
   this.numberPattern=/-?\d*\.?\d+(?:e[-+]?\d+)?/gi;
   this.paths=[...this.querySelectorAll('.amz-about__path[data-path-to]')].map(el=>{
    const from=el.getAttribute('d'),to=el.dataset.pathTo;
    const a=(from.match(this.numberPattern)||[]).map(Number),b=(to.match(this.numberPattern)||[]).map(Number);
    return {el,svg:el.closest('svg'),from,to,a,b,parts:from.split(this.numberPattern),last:-1};
   }).filter(p=>p.a.length===p.b.length);
   this.queue=()=>{if(!this.frame)this.frame=requestAnimationFrame(()=>{this.frame=0;this.update()})};
   this.preference=()=>{this.paths.forEach(p=>p.last=-1);this.queue()};
   document.addEventListener('scroll',this.queue,{passive:true,capture:true});
   window.addEventListener('resize',this.queue,{passive:true});
   this.reduced.addEventListener('change',this.preference);
   this.observer=new ResizeObserver(this.queue);this.observer.observe(this);
   this.queue();
  }
  update(){
   const motion=this.dataset.motion==='true'&&!this.reduced.matches;
   const height=window.innerHeight;
   const rects=new Map();
   this.paths.forEach(p=>{
    if(!rects.has(p.svg))rects.set(p.svg,p.svg.getBoundingClientRect());
    const r=rects.get(p.svg);
    const progress=motion?Math.max(0,Math.min(1,(height-r.top)/(height+r.height))):0;
    if(Math.abs(progress-p.last)<.0005)return;
    p.last=progress;
    let d=p.parts[0];
    for(let i=0;i<p.a.length;i++)d+=(p.a[i]+(p.b[i]-p.a[i])*progress).toFixed(3)+p.parts[i+1];
    p.el.setAttribute('d',d);
   });
  }
  disconnectedCallback(){
   document.removeEventListener('scroll',this.queue,true);window.removeEventListener('resize',this.queue);
   this.reduced?.removeEventListener('change',this.preference);this.observer?.disconnect();cancelAnimationFrame(this.frame);
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-academy-benefits"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('cm-academy-benefits'))customElements.define('cm-academy-benefits',class extends HTMLElement{
 connectedCallback(){
  this.controller=new AbortController();const {signal}=this.controller;
  this.cards=[...this.querySelectorAll('.cm-academy-benefits__card')];this.reduced=matchMedia('(prefers-reduced-motion: reduce)');this.forced=false;
  this.refresh=()=>{this.classList.toggle('is-animated',this.dataset.motion==='true'&&!this.reduced.matches);this.schedule();};
  this.schedule=()=>{if(this.frame)return;this.frame=requestAnimationFrame(()=>{this.frame=0;this.update();});};
  document.addEventListener('scroll',this.schedule,{passive:true,capture:true,signal});window.addEventListener('resize',this.schedule,{signal});this.reduced.addEventListener('change',this.refresh,{signal});
  this.querySelector('button').addEventListener('click',()=>{this.forced=true;this.update();},{signal});this.refresh();
 }
 update(){
  const smooth=v=>{v=Math.max(0,Math.min(1,v));return v*v*(3-2*v);};
  const mobile=matchMedia('(max-width:749px)').matches;const active=this.classList.contains('is-animated')&&(mobile||window.innerHeight>=780);
  const header=document.querySelector('header-component')?.getBoundingClientRect().height||80;
  this.style.setProperty('--benefits-header',`${header}px`);
  const rect=this.getBoundingClientRect(),height=window.innerHeight-header;
  const progress=Math.max(0,Math.min(1,(header-rect.top)/Math.max(1,rect.height-height)));
  this.style.setProperty('--benefits-progress',this.forced?1:progress);
  this.cards.forEach((card,i)=>{
   let spread=1,flip=1,scale=1,y=0,x=0,turn=0;
   if(active&&!this.forced){
    if(mobile){const r=card.getBoundingClientRect();flip=smooth((window.innerHeight*.86-r.top)/(window.innerHeight*.5));}
    else{const p=Math.max(0,Math.min(1,(progress-i*.035)/.8));spread=smooth((p-.18)/.46);flip=smooth((p-.52)/.35);scale=.48+.52*smooth(p/.52);y=(1-smooth(p/.4))*-26;const distance=card.offsetWidth+24;x=(1-spread)*((this.cards.length-1)/2-i)*distance;turn=(1-spread)*(i-1)*9;}
   }
   card.style.transform=`translate(${x}px,${y}px) rotate(${turn}deg) scale(${scale})`;
   card.querySelector('.cm-academy-benefits__inner').style.transform=`rotateY(${flip*180}deg)`;
  });
 }
 disconnectedCallback(){this.controller?.abort();cancelAnimationFrame(this.frame);}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-coffee-grid"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('cm-coffee-carousel'))customElements.define('cm-coffee-carousel',class extends HTMLElement{
 connectedCallback(){
  this.abort=new AbortController();const signal=this.abort.signal;
  this.track=this.querySelector('.cm-coffee-carousel__track');this.slides=[...this.querySelectorAll('.cm-coffee-carousel__slide')];this.controls=this.querySelector('.cm-coffee-carousel__controls');this.buttons=[...this.querySelectorAll('[data-step]')];this.status=this.querySelector('[role="status"]');this.index=0;
  this.update=()=>{this.frame=0;const grid=matchMedia('(max-width:749px)').matches&&this.dataset.mobileLayout==='grid';const overflow=this.track.scrollWidth>this.track.clientWidth+2;this.controls.hidden=grid||!overflow;this.track.tabIndex=grid||!overflow?-1:0;if(!this.slides.length)return;const rtl=getComputedStyle(this.track).direction==='rtl';const r=this.track.getBoundingClientRect();const distances=this.slides.map(s=>{const b=s.getBoundingClientRect();return Math.abs(rtl?r.right-b.right:b.left-r.left)});this.index=distances.indexOf(Math.min(...distances));const max=this.track.scrollWidth-this.track.clientWidth;const pos=Math.abs(this.track.scrollLeft);this.buttons[0].disabled=pos<2;this.buttons[1].disabled=pos>=max-2;const visible=this.slides.filter(s=>{const b=s.getBoundingClientRect();return b.left>=r.left-2&&b.right<=r.right+2}).length;const last=Math.min(this.slides.length,this.index+Math.max(1,visible));this.querySelector('.cm-coffee-carousel__count').textContent=(last>this.index+1?`${this.index+1} - ${last}`:`${this.index+1}`)+` / ${this.slides.length}`;this.style.setProperty('--coffee-progress',`${max>0?(this.track.clientWidth+pos)/this.track.scrollWidth*100:100}%`);};
  this.schedule=()=>{if(!this.frame)this.frame=requestAnimationFrame(this.update)};
  this.move=step=>{const next=Math.max(0,Math.min(this.slides.length-1,this.index+step));const slide=this.slides[next];if(!slide)return;const r=this.track.getBoundingClientRect(),b=slide.getBoundingClientRect(),rtl=getComputedStyle(this.track).direction==='rtl';this.track.scrollTo({left:this.track.scrollLeft+(rtl?b.right-r.right:b.left-r.left),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});};
  this.buttons.forEach(b=>b.addEventListener('click',()=>this.move(Number(b.dataset.step)),{signal}));
  this.track.addEventListener('keydown',e=>{if(e.target!==this.track)return;const rtl=getComputedStyle(this.track).direction==='rtl';if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.move((e.key==='ArrowRight'?1:-1)*(rtl?-1:1));}},{signal});
  this.track.addEventListener('scroll',this.schedule,{passive:true,signal});this.track.addEventListener('scrollend',()=>{this.update();this.status.textContent=this.status.dataset.statusTemplate.replace('[index]',this.index+1).replace('[length]',this.slides.length)},{signal});
  this.resize=new ResizeObserver(this.schedule);this.resize.observe(this.track);this.classList.add('is-ready');this.update();
 }
 disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();cancelAnimationFrame(this.frame)}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-coffee-grove"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('cm-coffee-grove')){
class CoffeeGrove extends HTMLElement{
 connectedCallback(){
  this.abort=new AbortController();this.reduced=matchMedia('(prefers-reduced-motion: reduce)');this.stage=this.querySelector('.cm-grove__stage');this.ending=this.querySelector('.cm-grove__ending');this.canvas=this.querySelector('canvas');this.active=false;
  this.schedule=()=>{if(!this.frame)this.frame=requestAnimationFrame(()=>{this.frame=0;this.paint();});};
  this.configure=()=>{this.active=this.dataset.motion==='true'&&document.body.dataset.cmMotion!=='false'&&!this.reduced.matches;this.classList.toggle('is-animated',this.active);this.ending.inert=this.active;if(this.active){if(!this.gl)this.setupGL();else this.classList.add('is-webgl');}else{this.classList.remove('is-webgl');Array.from(this.style).filter(k=>k.startsWith('--grove-')&&k!=='--grove-length').forEach(k=>this.style.removeProperty(k));}this.schedule();};
  document.addEventListener('scroll',this.schedule,{capture:true,passive:true,signal:this.abort.signal});window.addEventListener('resize',this.schedule,{passive:true,signal:this.abort.signal});this.reduced.addEventListener('change',this.configure,{signal:this.abort.signal});
  this.observer=new ResizeObserver(this.schedule);this.observer.observe(this.stage);this.mutation=new MutationObserver(this.configure);this.mutation.observe(document.body,{attributes:true,attributeFilter:['data-cm-motion']});
  this.canvas.addEventListener('webglcontextlost',e=>{e.preventDefault();this.classList.remove('is-webgl');this.gl=null;this.schedule();},{signal:this.abort.signal});
  this.configure();
 }
 setupGL(){
  try{
   const gl=this.canvas.getContext('webgl',{alpha:true,antialias:false,premultipliedAlpha:true});if(!gl)return;
   const shader=(type,source)=>{const s=gl.createShader(type);gl.shaderSource(s,source);gl.compileShader(s);if(!gl.getShaderParameter(s,gl.COMPILE_STATUS)){gl.deleteShader(s);throw Error('Shader unavailable');}return s;};
   const vs=shader(gl.VERTEX_SHADER,'attribute vec2 position;varying vec2 uv;void main(){uv=position*.5+.5;gl_Position=vec4(position,0.,1.);}');
   const fs=shader(gl.FRAGMENT_SHADER,`precision mediump float;varying vec2 uv;uniform float progress;uniform float aspect;uniform vec3 sand;
   float hash(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453);}float noise(vec2 p){vec2 i=floor(p),f=fract(p);f=f*f*(3.-2.*f);return mix(mix(hash(i),hash(i+vec2(1.,0.)),f.x),mix(hash(i+vec2(0.,1.)),hash(i+vec2(1.,1.)),f.x),f.y);}
   void main(){vec2 p=uv*vec2(aspect,1.)*4.;float n=noise(p)*.13+noise(p*2.3)*.065+noise(p*5.7)*.022;float edge=progress*1.65-.28+n;float a=1.-smoothstep(edge-.11,edge+.08,uv.y);a=progress<=0.?0.:progress>=1.?1.:a;gl_FragColor=vec4(sand*a,a);}`);
   const program=gl.createProgram();gl.attachShader(program,vs);gl.attachShader(program,fs);gl.linkProgram(program);gl.deleteShader(vs);gl.deleteShader(fs);if(!gl.getProgramParameter(program,gl.LINK_STATUS))throw Error('Program unavailable');
   gl.useProgram(program);const buffer=gl.createBuffer();gl.bindBuffer(gl.ARRAY_BUFFER,buffer);gl.bufferData(gl.ARRAY_BUFFER,new Float32Array([-1,-1,1,-1,-1,1,-1,1,1,-1,1,1]),gl.STATIC_DRAW);const pos=gl.getAttribLocation(program,'position');gl.enableVertexAttribArray(pos);gl.vertexAttribPointer(pos,2,gl.FLOAT,false,0,0);
   this.gl=gl;this.program=program;this.buffer=buffer;this.uniforms={progress:gl.getUniformLocation(program,'progress'),aspect:gl.getUniformLocation(program,'aspect'),sand:gl.getUniformLocation(program,'sand')};this.classList.add('is-webgl');
  }catch(e){this.classList.remove('is-webgl');this.gl=null;}
 }
 paint(){
  if(!this.active){this.ending.inert=false;return;}
  const rect=this.getBoundingClientRect();if(rect.bottom<0||rect.top>innerHeight)return;
  const stage=this.stage.getBoundingClientRect();const top=parseFloat(getComputedStyle(this.stage).top)||0;const clamp=n=>Math.max(0,Math.min(1,n));const smooth=n=>{const x=clamp(n);return x*x*(3-2*x);};const p=clamp((top-rect.top)/Math.max(1,rect.height-stage.height));
  const dissolve=smooth((p-.23)/.62),end=smooth((p-.50)/.20),intro=1-smooth((p-.12)/.27);const w=stage.width,h=stage.height;
  const vars={'intro':intro,'intro-y':`${-p*h*.16}px`,'ending':end,'end-y':`${(1-end)*25}px`,'wash':dissolve,'dissolve-visible':dissolve>0?1:0,'land-y':`${-p*h*.08}px`,'scale':1.04+p*.12,'left-x':`${-p*w*.16}px`,'left-y':`${-p*h*.43}px`,'right-x':`${p*w*.18}px`,'right-y':`${-p*h*.64}px`};Object.entries(vars).forEach(([k,v])=>this.style.setProperty(`--grove-${k}`,v));this.ending.inert=end<.9;
  if(this.gl){const gl=this.gl;const dpr=Math.min(devicePixelRatio||1,1.5);const width=Math.round(w*dpr),height=Math.round(h*dpr);if(this.canvas.width!==width||this.canvas.height!==height){this.canvas.width=width;this.canvas.height=height;gl.viewport(0,0,width,height);}const rgb=getComputedStyle(this.stage).backgroundColor.match(/[\d.]+/g)||[245,230,211];gl.useProgram(this.program);gl.uniform1f(this.uniforms.progress,dissolve);gl.uniform1f(this.uniforms.aspect,w/h);gl.uniform3f(this.uniforms.sand,rgb[0]/255,rgb[1]/255,rgb[2]/255);gl.drawArrays(gl.TRIANGLES,0,6);}
 }
 disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.mutation?.disconnect();cancelAnimationFrame(this.frame);if(this.gl){this.gl.deleteBuffer(this.buffer);this.gl.deleteProgram(this.program);this.gl.getExtension('WEBGL_lose_context')?.loseContext();this.gl=null;}}
}
customElements.define('cm-coffee-grove',CoffeeGrove);
}

if(!customElements.get('cm-grove-film')){
 class GroveFilm extends HTMLElement{
  connectedCallback(){
   this.video=this.querySelector('video');if(!this.video)return;
   this.abort=new AbortController();this.reduced=matchMedia('(prefers-reduced-motion: reduce)');this.visible=false;this.userPaused=false;this.systemPauses=0;this.video.muted=true;
   const signal=this.abort.signal;
   this.toggle=this.querySelector('.cm-grove-film__toggle');
   this.updateControl=()=>{this.toggle.textContent=this.video.paused?this.dataset.playLabel:this.dataset.pauseLabel;};
   this.video.controls=false;this.toggle.hidden=false;this.updateControl();
   this.toggle.addEventListener('click',()=>{if(this.video.paused){this.video.play().catch(()=>{});}else{this.userPaused=true;this.video.pause();}},{signal});
   this.video.addEventListener('play',this.updateControl,{signal});this.video.addEventListener('pause',this.updateControl,{signal});this.video.addEventListener('ended',this.updateControl,{signal});
   this.revealed=()=>!this.closest('.cm-grove__ending')?.inert;
   this.allowed=()=>this.dataset.autoplay==='true'&&!this.reduced.matches&&document.body.dataset.cmMotion!=='false';
   this.stop=()=>{if(!this.video.paused){this.systemPauses++;this.video.pause();}};
   this.sync=()=>{
    if(!this.visible||!this.revealed()||document.hidden){this.stop();return;}
    if(this.allowed()&&!this.userPaused&&!this.starting&&this.video.paused){this.starting=true;this.video.play().catch(()=>{}).finally(()=>{this.starting=false;if(!this.isConnected||!this.visible||!this.revealed()||document.hidden)this.stop();});}
   };
   this.video.addEventListener('pause',()=>{if(this.systemPauses){this.systemPauses--;return;}if(this.visible&&this.revealed()&&!document.hidden&&this.allowed())this.userPaused=true;},{signal});
   this.video.addEventListener('play',()=>{this.userPaused=false;},{signal});
   this.video.addEventListener('ended',()=>{this.userPaused=true;},{signal});
   this.loadObserver=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){this.video.preload='metadata';this.loadObserver.disconnect();}},{rootMargin:'600px 0px'});this.loadObserver.observe(this);
   this.revealObserver=new MutationObserver(this.sync);const ending=this.closest('.cm-grove__ending');if(ending)this.revealObserver.observe(ending,{attributes:true,attributeFilter:['inert']});
   this.playObserver=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting&&entries[0].intersectionRatio>=.25;this.sync();},{threshold:[0,.25]});this.playObserver.observe(this.video);
   document.addEventListener('visibilitychange',this.sync,{signal});
   this.preferences=()=>{if(!this.allowed())this.stop();else this.sync();};
   this.reduced.addEventListener('change',this.preferences,{signal});
   this.settingsObserver=new MutationObserver(this.preferences);this.settingsObserver.observe(document.body,{attributes:true,attributeFilter:['data-cm-motion']});
  }
  disconnectedCallback(){this.abort?.abort();this.loadObserver?.disconnect();this.playObserver?.disconnect();this.revealObserver?.disconnect();this.settingsObserver?.disconnect();this.video?.pause();}
 }
 customElements.define('cm-grove-film',GroveFilm);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-coffee-moments"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cm-coffee-moments')) {
    customElements.define('cm-coffee-moments', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.animations = [];
        const reduced = matchMedia('(prefers-reduced-motion: reduce)');
        if (this.dataset.motion !== 'true' || reduced.matches || window.Shopify?.designMode || !Element.prototype.animate || document.body.dataset.cmMotion !== 'true') return;
        const played = new WeakSet();
        const check = () => {
          this.frame = 0;
          if (reduced.matches) return;
          const height = window.innerHeight;
          this.querySelectorAll('[data-moment]').forEach((item, index) => {
            const rect = item.getBoundingClientRect();
            if (!played.has(item) && rect.top < height * .68 && rect.bottom > height * .2) {
              played.add(item);
              this.animations.push(item.animate([
                { opacity: .35, clipPath: 'inset(22% 0 22% 0 round 20px)', transform: 'translateY(24px)' },
                { opacity: 1, clipPath: 'inset(0% 0 0% 0 round 20px)', transform: 'translateY(0)' }
              ], { duration: 1100, delay: matchMedia('(min-width: 750px)').matches ? index * 120 : 0, easing: 'cubic-bezier(.22,.7,.2,1)', fill: 'backwards' }));
            }
          });
        };
        const queue = () => { if (!this.frame) this.frame = requestAnimationFrame(check); };
        document.addEventListener('scroll', queue, { capture: true, passive: true, signal: this.controller.signal });
        window.addEventListener('resize', queue, { passive: true, signal: this.controller.signal });
        reduced.addEventListener('change', () => {
          if (reduced.matches) this.animations.forEach(animation => animation.cancel());
        }, { signal: this.controller.signal });
        queue();
      }
      disconnectedCallback() {
        this.controller?.abort();
        cancelAnimationFrame(this.frame);
        this.animations?.forEach(animation => animation.cancel());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-contact-amz"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('cm-contact-amz')){
 customElements.define('cm-contact-amz',class extends HTMLElement{
  connectedCallback(){
   this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
   this.numberPattern=/-?\d*\.?\d+(?:e[-+]?\d+)?/gi;
   this.paths=[...this.querySelectorAll('.amz-about__path[data-path-to]')].map(el=>{
    const from=el.getAttribute('d'),to=el.dataset.pathTo;
    const a=(from.match(this.numberPattern)||[]).map(Number),b=(to.match(this.numberPattern)||[]).map(Number);
    return {el,svg:el.closest('svg'),from,to,a,b,parts:from.split(this.numberPattern),last:-1};
   }).filter(p=>p.a.length===p.b.length);
   this.queue=()=>{if(!this.frame)this.frame=requestAnimationFrame(()=>{this.frame=0;this.update()})};
   this.preference=()=>{this.paths.forEach(p=>p.last=-1);this.queue()};
   document.addEventListener('scroll',this.queue,{passive:true,capture:true});
   window.addEventListener('resize',this.queue,{passive:true});
   this.reduced.addEventListener('change',this.preference);
   this.observer=new ResizeObserver(this.queue);this.observer.observe(this);
   this.queue();
  }
  update(){
   const motion=this.dataset.motion==='true'&&!this.reduced.matches;
   const height=window.innerHeight;
   const rects=new Map();
   this.paths.forEach(p=>{
    if(!rects.has(p.svg))rects.set(p.svg,p.svg.getBoundingClientRect());
    const r=rects.get(p.svg);
    const progress=motion?Math.max(0,Math.min(1,(height-r.top)/(height+r.height))):0;
    if(Math.abs(progress-p.last)<.0005)return;
    p.last=progress;
    let d=p.parts[0];
    for(let i=0;i<p.a.length;i++)d+=(p.a[i]+(p.b[i]-p.a[i])*progress).toFixed(3)+p.parts[i+1];
    p.el.setAttribute('d',d);
   });
  }
  disconnectedCallback(){
   document.removeEventListener('scroll',this.queue,true);window.removeEventListener('resize',this.queue);
   this.reduced?.removeEventListener('change',this.preference);this.observer?.disconnect();cancelAnimationFrame(this.frame);
  }
 });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-depth-hero"] && !Shopify.designMode) return;
  try {
    
  class CMCoffeeFilm extends HTMLElement {
    connectedCallback(){
      this.video=this.querySelector('video');if(!this.video)return;
      this.button=this.closest('.cm-depth').querySelector('[data-film-toggle]');
      this.controller=new AbortController();const signal=this.controller.signal;
      this.reduced=matchMedia('(prefers-reduced-motion: reduce)');this.userPaused=false;this.explicitPlay=false;this.visible=false;
      this.video.muted=true;
      this.sync=()=>{const playing=!this.video.paused;this.button.textContent=playing?this.button.dataset.pause:this.button.dataset.play;this.button.setAttribute('aria-pressed',String(playing));};
      this.button.addEventListener('click',()=>{if(this.video.paused){this.userPaused=false;this.explicitPlay=true;this.video.play().catch(this.sync);}else{this.userPaused=true;this.video.pause();}},{signal});
      this.video.addEventListener('play',this.sync,{signal});this.video.addEventListener('pause',this.sync,{signal});
      document.addEventListener('visibilitychange',()=>this.update(),{signal});
      this.reduced.addEventListener('change',()=>{this.explicitPlay=false;this.update();},{signal});
      this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.update();});this.observer.observe(this.closest('.cm-depth'));this.sync();
    }
    update(){
      const motionAllowed=this.explicitPlay||(!this.reduced.matches&&document.body.dataset.cmMotion==='true');
      if(this.visible&&!document.hidden&&!this.userPaused&&motionAllowed)this.video.play().catch(this.sync);else this.video.pause();
    }
    disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();this.video?.pause();}
  }
  if(!customElements.get('cm-coffee-film'))customElements.define('cm-coffee-film',CMCoffeeFilm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-editorial"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('cm-editorial-montage')){
 customElements.define('cm-editorial-montage',class extends HTMLElement{
  connectedCallback(){
   this.animations=[];this.abort=new AbortController();this.motion=matchMedia('(prefers-reduced-motion:reduce)');this.intro=this.querySelector('.cm-montage__intro');this.stage=this.querySelector('.cm-montage__stage');
   this.setupFlips();
   if(this.dataset.motion!=='true'||this.motion.matches||window.Shopify?.designMode||!Element.prototype.animate)return;
   this.cards=[...this.querySelectorAll('.cm-montage__card')].reverse();if(this.cards.some(card=>!card.querySelector('img')))return;
   this.classList.add('is-armed');
   this.observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){this.cards.forEach(card=>{card.querySelector('img').loading='eager';});this.observer.disconnect();}},{rootMargin:'100% 0px',threshold:0});this.observer.observe(this.deck);
   this.checkPosition=()=>{if(this.positionFrame||this.started||this.done)return;this.positionFrame=requestAnimationFrame(()=>{this.positionFrame=0;const rect=this.deck.getBoundingClientRect();const header=document.querySelector('header-component')?.getBoundingClientRect().bottom||0;const top=Math.max(0,header);const center=top+(innerHeight-top)*.5;if(rect.bottom<=top){this.finish();return;}if(rect.top+rect.height/2<=center)this.reveal();});};
   document.addEventListener('scroll',this.checkPosition,{capture:true,passive:true,signal:this.abort.signal});this.checkPosition();
   this.motion.addEventListener('change',()=>{if(this.motion.matches)this.finish();},{signal:this.abort.signal});
   document.addEventListener('visibilitychange',()=>{if(document.hidden){this.stopFlip();this.finish();}},{signal:this.abort.signal});
   this.width=innerWidth;window.addEventListener('resize',()=>{if(this.width!==innerWidth){this.width=innerWidth;this.stopFlip();this.finish();}},{signal:this.abort.signal});
  }
  setupFlips(){
   this.deck=this.querySelector('.cm-montage__deck');this.photoCards=[...this.deck.querySelectorAll('.cm-montage__card')];this.active=0;this.flipAnimations=[];this.flipping=false;this.suppressClickUntil=0;
   this.slots=['rotate(-2deg)','translate(5%,-5%) rotate(6deg)','translate(-5%,-9%) rotate(-9deg)'];
   const hit=this.deck.querySelector('.cm-montage__flip'),controls=this.deck.querySelector('.cm-montage__controls'),options={signal:this.abort.signal};
   if(this.photoCards.filter(card=>card.querySelector('img')).length<2)return;
   hit.hidden=false;controls.hidden=false;this.photoCards.forEach(card=>{const image=card.querySelector('img');if(image)image.draggable=false;});
   hit.addEventListener('click',()=>{if(performance.now()>=this.suppressClickUntil)this.flip(1);},options);
   controls.addEventListener('click',event=>{const button=event.target.closest('[data-card-direction]');if(button)this.flip(Number(button.dataset.cardDirection));},options);
   this.deck.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();this.flip(event.key==='ArrowLeft'?-1:1);}},options);
   hit.addEventListener('pointerdown',event=>{if(!event.isPrimary||event.button!==0)return;this.gesture={id:event.pointerId,x:event.clientX,y:event.clientY};hit.setPointerCapture(event.pointerId);},options);
   hit.addEventListener('pointerup',event=>{
    const gesture=this.gesture;if(!gesture||gesture.id!==event.pointerId)return;this.gesture=null;
    const dx=event.clientX-gesture.x,dy=event.clientY-gesture.y;
    if(Math.hypot(dx,dy)>12)this.suppressClickUntil=performance.now()+500;
    if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.3){this.suppressClickUntil=performance.now()+500;this.flip(dx<0?1:-1);}
    if(hit.hasPointerCapture(event.pointerId))hit.releasePointerCapture(event.pointerId);
   },options);
   hit.addEventListener('pointercancel',()=>{this.gesture=null;this.suppressClickUntil=performance.now()+500;},options);
   this.motion.addEventListener('change',()=>{if(this.motion.matches)this.stopFlip();},options);
  }
  syncCards(announce=true){
   this.photoCards.forEach((card,i)=>{const rank=(i-this.active+this.photoCards.length)%this.photoCards.length;card.style.zIndex=String(3-rank);card.style.transform=this.slots[rank];card.setAttribute('aria-hidden',String(rank!==0));});
   this.deck.querySelector('.cm-montage__count').textContent=(this.active+1)+' / '+this.photoCards.length;
   if(announce)this.deck.querySelector('.cm-montage__status').textContent=this.deck.dataset.statusTemplate.replace('[index]',String(this.active+1));
  }
  async flip(direction){
   if(this.flipping||this.classList.contains('is-armed')||this.classList.contains('is-playing'))return;
   if(this.motion.matches||!Element.prototype.animate){this.active=(this.active+direction+this.photoCards.length)%this.photoCards.length;this.syncCards();return;}
   this.flipping=true;const outgoing=this.photoCards[this.active];
   const before=this.photoCards.map(card=>getComputedStyle(card).transform);
   const animate=(card,frames,duration)=>{const animation=card.animate(frames,{duration,easing:'cubic-bezier(.22,.7,.2,1)',fill:'both'});this.flipAnimations.push(animation);return animation;};
   try{
    outgoing.style.zIndex='5';
    await animate(outgoing,[{transform:before[this.active],opacity:1},{transform:'translateX('+(-direction*38)+'%) rotateY('+(-direction*80)+'deg) rotateZ('+(-direction*12)+'deg) scale(.94)',opacity:0}],260).finished;
    this.active=(this.active+direction+this.photoCards.length)%this.photoCards.length;this.syncCards();
    this.flipAnimations.forEach(animation=>animation.cancel());this.flipAnimations=[];
    const settling=this.photoCards.map((card,i)=>animate(card,[{transform:card===outgoing?'translateX('+(direction*22)+'%) rotateY('+(direction*70)+'deg) scale(.94)':before[i],opacity:card===outgoing?0:1},{transform:card.style.transform,opacity:1}],360));
    await Promise.all(settling.map(animation=>animation.finished));
   }catch{}finally{this.flipAnimations.forEach(animation=>animation.cancel());this.flipAnimations=[];this.flipping=false;this.syncCards(false);}
  }
  stopFlip(){this.flipAnimations?.forEach(animation=>animation.cancel());this.gesture=null;}
  async reveal(){
   if(this.started||this.done)return;this.started=true;
   try{
    const tiles=this.cards.map((card,i)=>{const tile=document.createElement('div'),image=card.querySelector('img').cloneNode();tile.className='cm-montage__intro-card';tile.style.zIndex=String(i+1);image.loading='eager';image.sizes='100vw';tile.append(image);this.intro.append(tile);return tile;});
    await Promise.race([Promise.all(tiles.map(tile=>tile.firstElementChild.decode().catch(()=>{}))),new Promise(resolve=>{this.loadTimer=setTimeout(resolve,1400);})]);
    clearTimeout(this.loadTimer);if(!this.isConnected||this.done)return;
    const stage=this.stage.getBoundingClientRect(),deck=this.querySelector('.cm-montage__deck');
    const mobile=matchMedia('(max-width:749px)').matches;
    const introTop=mobile?Math.max(0,deck.offsetTop-28):0;
    const introHeight=mobile?Math.min(stage.height-introTop,deck.offsetHeight+56):stage.height;
    this.intro.style.top=introTop+'px';this.intro.style.bottom='auto';this.intro.style.height=introHeight+'px';
    const animate=(el,frames,options)=>{const animation=el.animate(frames,{fill:'both',easing:'cubic-bezier(.22,.7,.2,1)',...options});this.animations.push(animation);return animation;};
    this.classList.remove('is-armed');this.classList.add('is-playing');
    tiles.forEach((tile,i)=>{
     const card=this.cards[i],style=getComputedStyle(card);
     const full={left:'0px',top:'0px',width:stage.width+'px',height:introHeight+'px',transform:'none',borderWidth:'0px',borderRadius:'0px'};
     const final={left:(deck.offsetLeft+card.offsetLeft)+'px',top:(deck.offsetTop+card.offsetTop-introTop)+'px',width:card.offsetWidth+'px',height:card.offsetHeight+'px',transform:style.transform,borderWidth:style.borderTopWidth,borderRadius:style.borderTopLeftRadius};
     animate(tile,[{...full,opacity:i===0?1:0},{...full,opacity:1,offset:.25},{...full,opacity:1,offset:.55},{...final,opacity:1}],{duration:2350,delay:i*180});
     animate(tile.firstElementChild,[{transform:'scale(1.12)'},{transform:'scale(1)',offset:.55},{transform:'scale(1)'}],{duration:2350,delay:i*180});
    });
    const upper=document.createElement('div'),lower=document.createElement('div');upper.className=lower.className='cm-montage__curtain';upper.style.top='0';lower.style.bottom='0';this.intro.append(upper,lower);
    animate(upper,[{transform:'translateY(0)'},{transform:'translateY(-100%)'}],{duration:850});
    animate(lower,[{transform:'translateY(0)'},{transform:'translateY(100%)'}],{duration:850});
    const ending=animate(this.querySelector('.cm-montage__content'),[{opacity:0,transform:'translateY(35px)'},{opacity:1,transform:'translateY(0)'}],{duration:1000,delay:1850});
    ending.finished.then(()=>this.finish()).catch(()=>{});
   }catch{this.finish();}
  }
  finish(){this.done=true;cancelAnimationFrame(this.positionFrame);document.removeEventListener('scroll',this.checkPosition,true);clearTimeout(this.loadTimer);this.observer?.disconnect();for(const animation of this.animations)animation.cancel();this.animations=[];this.classList.remove('is-armed','is-playing');this.intro?.replaceChildren();}
  disconnectedCallback(){this.abort?.abort();this.stopFlip();this.finish();}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-footer"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('cm-google-rating')){
  const safeURL=value=>{try{const url=new URL(value);return url.protocol==='https:'&&!url.username&&!url.password?url.href:null;}catch{return null;}};
  const mapsURL=value=>{const href=safeURL(value);if(!href)return null;const host=new URL(href).hostname;return ['google.com','www.google.com','maps.google.com','maps.app.goo.gl'].includes(host)?href:null;};
  customElements.define('cm-google-rating',class extends HTMLElement{
    connectedCallback(){
      if(this.started)return;
      if(this.dataset.preview==='true'&&window.Shopify?.designMode){
        this.started=true;
        this.renderRating({rating:5.0,reviewCount:327,mapsUrl:'https://www.google.com/maps'},true);
        return;
      }
      this.renderRating({rating:Number(this.dataset.fallbackRating),reviewCount:Number(this.dataset.fallbackCount),mapsUrl:this.dataset.fallbackUrl});
      if(!this.dataset.endpoint){this.started=true;return;}
      this.observer=new IntersectionObserver(entries=>{
        if(entries.some(entry=>entry.isIntersecting)){this.observer.disconnect();this.load();}
      });
      this.observer.observe(this);
    }
    async load(){
      if(this.started)return;
      this.started=true;
      const endpoint=safeURL(this.dataset.endpoint);
      if(!endpoint)return;
      const controller=new AbortController();
      this.controller=controller;
      const timer=setTimeout(()=>controller.abort(),10000);
      try{
        const response=await fetch(endpoint,{credentials:'omit',referrerPolicy:'no-referrer',signal:controller.signal});
        if(!response.ok)throw new Error('Rating unavailable');
        const data=await response.json();
        if(this.isConnected&&!controller.signal.aborted)this.renderRating(data);
      }catch{
      }finally{
        clearTimeout(timer);
        if(this.controller===controller)this.controller=null;
      }
    }
    renderRating(data,preview=false){
      const badge=this.querySelector('.cm-google-rating__badge');
      const rating=data?.rating,count=data?.reviewCount,url=mapsURL(data?.mapsUrl);
      if(!Number.isFinite(rating)||rating<1||rating>5||!Number.isInteger(count)||count<1||!url)return;
      const locale=document.documentElement.lang||'en';
      const score=rating.toLocaleString(locale,{minimumFractionDigits:1,maximumFractionDigits:1});
      const number=count.toLocaleString(locale);
      this.querySelector('.cm-google-rating__score').textContent=score;
      this.querySelector('.cm-google-rating__stars').style.setProperty('--rating-fill',`${Math.round(rating*2000)/100}%`);
      this.querySelector('.cm-google-rating__count').textContent=this.dataset.reviewLabel.replace('[count]',number);
      if(preview)badge.removeAttribute('href');else badge.href=url;
      badge.setAttribute('aria-label',this.dataset.accessibleLabel.replace('[rating]',score).replace('[count]',number));
      this.querySelector('.cm-google-rating__attributions').replaceChildren();
      badge.hidden=false;
    }
    disconnectedCallback(){
      this.observer?.disconnect();
      if(this.controller){this.controller.abort();this.controller=null;this.started=false;}
    }
  });
}
if(!customElements.get('cm-bean-lettering')){
  customElements.define('cm-bean-lettering',class extends HTMLElement{
    connectedCallback(){
      this.abort=new AbortController();
      const signal=this.abort.signal;
      this.canvas=this.querySelector('canvas');
      this.ctx=this.canvas.getContext('2d');
      this.label=this.querySelector('span');
      this.motion=matchMedia('(prefers-reduced-motion: reduce)');
      this.points=[];this.pointer=null;this.visible=false;this.frame=0;
      this.build=()=>{
        this.stop();this.classList.remove('is-ready');
        if(!this.ctx||this.motion.matches||!this.isConnected)return;
        const style=getComputedStyle(this.label),box=this.getBoundingClientRect();
        this.w=box.width;this.h=box.height+80;
        if(!this.w||!box.height)return;
        const dpr=Math.min(devicePixelRatio||1,2),size=parseFloat(style.fontSize);
        this.canvas.width=Math.round(this.w*dpr);this.canvas.height=Math.round(this.h*dpr);
        this.ctx.setTransform(dpr,0,0,dpr,0,0);
        const mask=document.createElement('canvas');mask.width=Math.ceil(this.w);mask.height=Math.ceil(this.h);
        const c=mask.getContext('2d',{willReadFrequently:true});
        c.font=`${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;
        c.letterSpacing=style.letterSpacing;c.fillStyle='#fff';c.textBaseline='alphabetic';
        const metrics=c.measureText(this.label.textContent);
        const baseline=40+(box.height+metrics.fontBoundingBoxAscent-metrics.fontBoundingBoxDescent)/2;
        c.fillText(this.label.textContent,0,Number.isFinite(baseline)?baseline:40+size*.8);
        const pixels=c.getImageData(0,0,mask.width,mask.height).data;
        const step=this.w<600?2.5:4.5;
        this.beanSize=this.w<600?2.1:3.8;
        this.radius=this.w<600?35:76;
        this.points=[];
        for(let y=40;y<this.h-35;y+=step){
          for(let x=step/2;x<this.w;x+=step){
            if(pixels[(Math.floor(y)*mask.width+Math.floor(x))*4+3]>95){
              this.points.push({x,y,dx:0,dy:0,vx:0,vy:0,angle:Math.random()*Math.PI,tone:Math.random()});
            }
          }
        }
        if(!this.points.length)return;
        this.draw();this.classList.add('is-ready');
      };
      this.stop=()=>{cancelAnimationFrame(this.frame);this.frame=0;this.pointer=null;this.classList.remove('is-interacting');};
      this.wake=()=>{if(!this.frame&&this.visible&&!this.motion.matches&&!document.hidden)this.frame=requestAnimationFrame(t=>this.tick(t));};
      const move=e=>{
        if(this.motion.matches)return;
        const r=this.getBoundingClientRect();
        this.classList.add('is-interacting');
        this.pointer={x:e.clientX-r.left,y:e.clientY-r.top+40,until:performance.now()+100};
        this.wake();
      };
      this.addEventListener('pointermove',move,{signal,passive:true});
      this.addEventListener('pointerdown',move,{signal,passive:true});
      for(const event of ['pointerleave','pointerup','pointercancel'])this.addEventListener(event,()=>{this.pointer=null;},{signal});
      this.resize=new ResizeObserver(()=>this.build());this.resize.observe(this);
      this.observer=new IntersectionObserver(entries=>{
        this.visible=entries[0].isIntersecting;
        if(!this.visible){this.stop();this.reset();}
      });this.observer.observe(this);
      document.addEventListener('visibilitychange',()=>{if(document.hidden){this.stop();this.reset();}},{signal});
      this.motion.addEventListener('change',this.build,{signal});
      document.fonts.ready.then(()=>{if(!signal.aborted)this.build();});
    }
    reset(){for(const p of this.points){p.dx=p.dy=p.vx=p.vy=0;}if(this.ctx)this.draw();}
    tick(now){
      this.frame=0;let moving=false;
      const pointer=this.pointer&&now<this.pointer.until?this.pointer:null;
      for(const p of this.points){
        if(pointer){
          const dx=p.x+p.dx-pointer.x,dy=p.y+p.dy-pointer.y,d=Math.hypot(dx,dy);
          if(d<this.radius){const f=(1-d/this.radius)*5.5;p.vx+=(dx/(d||1))*f;p.vy+=(dy/(d||1))*f;}
        }
        p.vx=(p.vx-p.dx*.055)*.82;p.vy=(p.vy-p.dy*.055)*.82;
        p.dx+=p.vx;p.dy+=p.vy;
        if(Math.abs(p.dx)+Math.abs(p.dy)+Math.abs(p.vx)+Math.abs(p.vy)>.08)moving=true;
        else p.dx=p.dy=p.vx=p.vy=0;
      }
      this.draw();if(moving||pointer)this.wake();else this.classList.remove('is-interacting');
    }
    draw(){
      const c=this.ctx;c.clearRect(0,0,this.w||0,this.h||0);
      for(const p of this.points){
        const s=this.beanSize;c.save();
        c.translate(Math.max(s,Math.min(this.w-s,p.x+p.dx)),p.y+p.dy);
        c.rotate(p.angle+p.dx*.015);
        c.fillStyle=p.tone>.18?'#f5e6d3':'#c49a6c';
        c.beginPath();c.ellipse(0,0,s*.42,s*.64,0,0,Math.PI*2);c.fill();
        c.strokeStyle='#513622';c.lineWidth=Math.max(.45,s*.16);c.lineCap='round';
        c.beginPath();c.moveTo(0,-s*.48);c.bezierCurveTo(-s*.3,-s*.15,s*.3,s*.15,0,s*.48);c.stroke();c.restore();
      }
    }
    disconnectedCallback(){this.abort.abort();this.stop();this.resize.disconnect();this.observer.disconnect();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-product-story"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('cm-brew-tabs'))customElements.define('cm-brew-tabs',class extends HTMLElement{connectedCallback(){this.onClick=e=>{const b=e.target.closest('[role="tab"]');if(!b)return;this.querySelectorAll('[role="tab"]').forEach(t=>t.setAttribute('aria-selected',String(t===b)));this.querySelectorAll('[role="tabpanel"]').forEach(p=>p.hidden=p.id!==b.getAttribute('aria-controls'));};this.addEventListener('click',this.onClick);}disconnectedCallback(){this.removeEventListener('click',this.onClick);}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
